module.exports = {
      id: "comm-environment-usage",
      viewBox: "0 0 276.484 47.102",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-environment",
      toString: function () {
        return this.url;
      }
    }